import React, {useEffect, useMemo, useState} from 'react';
import {connect} from 'react-redux';

import Reservations from './containers/Reservations';
import MakeOffers from './containers/MakeOffers';
import MyAds from './containers/MyAds';
import Dashboard from './containers/Dashboard';
import MyVisits from './containers/MyVisits';
import MyAccount from './containers/MyAccount';
import Payments from './containers/Payments';
import HorizontalNavBar from '../../components/HorizontalNavBar';
import Loading from '../../components/Loading';

import './style.less';
import {userActions} from '../../redux/actions';
import {useHistory, useLocation} from "react-router-dom";
import {isSm} from "../../utils/responsive";
import PagesSwitch from "../../components/PagesSwitch";
import {useAuth} from "../../services/authServices";
import MyCalendar from "./containers/MyCalendar";
import {usePlatform} from "../../context/PlatformContext";
import LegalInformation from "../LegalInformation";
import Config from "./containers/Config";

const pages = [
   {
   label: "main_page.dashboard.label",
   path: "dashboard",
   component: Dashboard,
   },
    {
       label: "main_page.leads.label",
    path: "leads",
   component: MakeOffers,
   },
   {
   label: "main_page.reservations.label",
   path: "reservations",
   component: Reservations,
   },
  {
    label: 'main_page.my_ads.label',
    path: 'my_ads',
    component: MyAds
  },
  {
   label: "main_page.my_visits.label",
   path: "my_visits",
   component: MyVisits
  },
  {
    label: "main_page.payments.label",
    path: "payments",
    component: Payments
  },
  /*{
   label: "main_page.my_calendar.label",
   path: "my_calendar",
   component: MyCalendar
  },*/
  {
    label: 'my_account.label',
    path: 'my_account',
    component: MyAccount
  },
  {
    label: 'config.label',
    path: 'config',
    component: Config,
    functionalities: ['how_did_you_hear_about_us', 'customizable_popups']
  },
    {
        path: 'legal/:page',
        component: LegalInformation
    }
];

const removePage = (path) => {
    const index = pages.findIndex(page => page.path === path);
    if (index !== -1) {
        pages.splice(index, 1);
    }
}

const MainPage = ({displayFooter}) => {

    const auth = useAuth();
    const history = useHistory();
    const {platform} = usePlatform();


    if (!platform?.functionalities?.includes('leads')) removePage('leads');
    if (!platform?.functionalities?.includes('visit_onsite') && !platform?.functionalities?.includes('visit_livecall')) removePage('my_visits');
    {
        const platformFunctionalities = platform?.functionalities || [];
        const configEntry = pages.find(p => p.path === 'config');
        console.log("platform?.functionalities", platform?.functionalities, configEntry)
        if (configEntry?.functionalities && !configEntry.functionalities.some(f => platformFunctionalities.includes(f))) {
            removePage('config');
        }
    }

    const isSmallScreen = useMemo(() => {
        return isSm();
    }, []);

    useEffect(() => {
        (async () => {
            let user = await auth.onLoaded();
            if (!user) {
                history.push('/start/login');
            } else if (window.location.pathname === '/') {
                history.push('/dashboard');
            }
        })();
    }, []);

    //if footer if show we need to limit the height
    const [limitedHeight, setLimitedHeight] = useState(!displayFooter.display);

    useEffect(() => {
        setLimitedHeight(!displayFooter.display);
    }, [displayFooter]);

    if (auth.loading) return <Loading/>;

    return (<><div
        className={`MainPage${limitedHeight ? ' limit-height' : ''}`}>
        {isSmallScreen ? <PagesSwitch path={"/"}
                                      pages={pages}
                                      loggedIn={auth.user}
                                      pageHeader={true}/>
            : <HorizontalNavBar path={"/"}
                                pages={pages}
                                loggedIn={auth.user}
                                pageHeader={true}/>
        }

    </div>
        {auth.internalLoading && <Loading cover={0.3}/>}
    </>);
};

function mapStateToProps(state) {
    return {displayFooter: state.footerDisplay};
}

export default connect(mapStateToProps, null)(MainPage);
